import script from "./sub2Option.vue?vue&type=script&setup=true&lang=js"
export * from "./sub2Option.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__